import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate, Trans} from "react-i18next";
import i18n from "i18next";

class TextBody extends React.Component {
    constructor(props){
        super(props);
    }

    /**
     * render
      * @returns {*}
     */
    render() {

        return <div>{i18n.t(this.props.textResource, this.props)}</div>

    }
}

export default translate("translations")(TextBody);